/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
import moment from 'moment';
import helper from '@/_libs/helper';
import permissions from './_permissions';

// const DATE_TODAY = moment().format('YYYY-MM-DD');

// const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
// const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
// const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const COL_TYPE = {
  PermissionLevels: 100,
  ActivationStatus: 101,
  LoginUrl: 102,
};

const PERMISSION_LEVELS = {
  SALE: 0,
  CS: 1,
  ADMIN: 2,
};

// const MOCK = {
//   sellerRecords: {
//     sellers: [
//       {
//         username: 'diana',
//         firstName: 'ปิยปราชญ์',
//         lastName: 'วัจนะประสิทธิ์',
//         // permissonLevel: PERMISSION_LEVELS.SALE,
//         enabled: true,
//         loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

//         imgSrc: 'http://placekitten.com/128/128',
//         id: '011023',
//         code: '08594111',
//         zone: 'NE',

//         email: 'someone@example.com',
//         phone: '08594333211',
//       },
//       {
//         username: 'campos',
//         firstName: 'ธายุกร',
//         lastName: 'ธรรมสรณ์',
//         // permissonLevel: PERMISSION_LEVELS.SALE,
//         enabled: false,
//         loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

//         imgSrc: 'http://placekitten.com/256/256',
//         id: '011023',
//         code: '08594111',
//         zone: 'NE',

//         email: 'someone@example.com',
//         phone: '08594333211',
//       },
//       {
//         username: 'Thepthep',
//         firstName: 'ธนากร',
//         lastName: 'อรรถพันธ์',
//         // permissonLevel: PERMISSION_LEVELS.SALE,
//         enabled: false,
//         loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

//         imgSrc: 'http://placekitten.com/200/200',
//         id: '011023',
//         code: '08594111',
//         zone: 'NE',

//         email: 'someone@example.com',
//         phone: '08594333211',
//       },
//       {
//         username: 'Suthat009',
//         firstName: 'ชนารดี',
//         lastName: 'พลลภัตม์',
//         // permissonLevel: PERMISSION_LEVELS.CS,
//         enabled: true,
//         loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

//         imgSrc: 'http://placekitten.com/96/96',
//         id: '011023',
//         code: '08594111',
//         zone: 'NE',

//         email: 'someone@example.com',
//         phone: '08594333211',
//       },
//       {
//         username: 'Eak98',
//         firstName: 'พลกฤต',
//         lastName: 'กานต์มณี',
//         // permissonLevel: PERMISSION_LEVELS.ADMIN,
//         enabled: true,
//         loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

//         imgSrc: 'http://placekitten.com/100/100',
//         id: '011023',
//         code: '08594111',
//         zone: 'NE',

//         email: 'someone@example.com',
//         phone: '08594333211',
//       },
//     ],
//   },
// };

const sellerRecords = {
  // Permission
  async sellerList(page = 1, filterSearch) {
    // return await helper.call('admin.sellerRecords.sellerList', {
    //   success: true,
    //   data: MOCK.sellerRecords.sellers,
    // }, async () => await axios(helper.path('admin/sellerRecords/seller-list')));
    
    // 1 = admin
    // 2 = cs
    // 3 = sales
    // 4 = approver
    const SALE_ROLE = 3;
    const res = await permissions.staffsList(page, filterSearch, SALE_ROLE);
    // res.data.data = res.data.data.filter(elm => (elm.permissionLevel === 0));
    return res;
  },

  async bestSellers(area = '') {
    if (area !== '') {
      return await helper.call('admin.bestSellers.area', {
      }, async () => await axios(helper.path(`salegoal/bestsellers/?area=${area}`)));
    }
    return await helper.call('admin.bestSellers.all', {
    }, async () => await axios(helper.path('salegoal/bestsellers/')));
  },

  async goalDashboard(userId, date = {}) {
    if (Object.keys(date).length === 0) {
      return await helper.call('user.goalDashboard', {
      }, async () => await axios(helper.path(`salegoal/stats?user_id=${userId}`)));
    }
    return await helper.call('user.goalDashboard', {
    }, async () => await axios(helper.path(`salegoal/stats?user_id=${userId}&from=${moment(date.from).format('YYYY-MM-DD hh:mm:ss')}&to=${moment(date.to).format('YYYY-MM-DD hh:mm:ss')}`))); // eslint-disable
  },

  async getCheckins(userId, date = {}) {
    if (Object.keys(date).length === 0) {
      return await helper.call('customers.history.checkins', {
        success: true,
      }, async () => await axios(helper.path(`user/${userId}/checkIns`)));
    }
    return await helper.call('customers.history.checkins', {
      success: true,
    }, async () => await axios(helper.path(`user/${userId}/checkIns?from=${moment(date.from).format('YYYY-MM-DD hh:mm:ss')}&to=${moment(date.to).format('YYYY-MM-DD hh:mm:ss')}`))); // eslint-disable
  },

  // upload
  async uploadSaleGoal(formData) {
    return await helper.call('salegoal.uploadSaleGoalFile', {
      // ...
    }, async () => await axios.post(helper.path('salegoal'),
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }));
  },

  PERMISSION_LEVELS,
  COL_TYPE,
};

export default sellerRecords;
